import { useStyletron } from 'baseui';
import { Navigation } from 'baseui/side-navigation';
import MatchingPanel from '../MatchingPanel';
import ProjectTypeMappingPanel from '../ProjectTypes';
import QATracker from '../QATracker';
import QualityInsights from '../QualityInsights';
import ReportQAPanel from '../ReportQA';
import { MARGINS_DASHBOARD_ID } from '../constants';
import { useQuality } from '../context';
export function QualityAppSideNav() {
  const [css] = useStyletron();
  const {
    activePanel,
    setActivePanel
  } = useQuality();
  const navItems = [{
    title: 'Margins',
    itemId: 'margins'
  }, {
    title: 'Tracker 🧪',
    itemId: 'tracker'
  }, {
    title: 'Project Types 🧪',
    itemId: 'types'
  }, {
    title: 'Matching',
    itemId: 'matching'
  }, {
    title: 'Report QA',
    itemId: 'reportqa'
  }];
  const contentComponents = {
    margins: <QualityInsights dashboardId={MARGINS_DASHBOARD_ID} />,
    matching: <MatchingPanel />,
    types: <ProjectTypeMappingPanel />,
    reportqa: <ReportQAPanel />,
    tracker: <QATracker />
  };
  return <div className={css({
    width: '100%',
    display: 'flex',
    flexDirection: 'row'
  })}>
      <Navigation items={navItems} activeItemId={activePanel} onChange={({
      event,
      item
    }) => {
      setActivePanel(item.itemId);
      event.preventDefault();
    }} />

      <div className={css({
      width: '100%'
    })}>
        {contentComponents[activePanel] || <div>Select a panel</div>}
      </div>
    </div>;
}
export default QualityAppSideNav;